const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Raiders extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.Raiders,
            "Each of the two weakest civilizations lose a total of 2 resources and/or food.",
            {}
        )
    }
}

module.exports = Raiders;